import React from 'react'

function cx(...classes: (string | boolean | undefined)[]) {
  return classes.filter(Boolean).join(' ')
}

interface BlobProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  style?: React.CSSProperties;
}

export default function Blob({ className = '', style, ...props }: BlobProps) {
  return (
    <div
      aria-hidden="true"
      className={cx(
        'pointer-events-none select-none rounded-full blur-3xl bg-gradient-to-br from-sand/70 via-shell/60 to-white/0',
        className,
      )}
      style={style}
      {...props}
    />
  )
}
